import { useEffect, useRef, useState } from 'react';
import { Archive, MoreHorizontal, Trash2 } from 'lucide-react';

export function SessionActionsMenu({
  onAction,
}: {
  onAction: (action: 'archive' | 'delete') => void;
}) {
  const menuRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const closeOnPointerDown = (event: PointerEvent) => {
      if (!menuRef.current?.contains(event.target as Node)) setOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', closeOnPointerDown);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnPointerDown);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, []);

  const selectAction = (action: 'archive' | 'delete') => {
    setOpen(false);
    onAction(action);
  };

  return (
    <div className={`more-menu${open ? ' open' : ''}`} ref={menuRef}>
      <button
        type="button"
        title="More actions"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <MoreHorizontal size={17} />
      </button>
      <div className="more-popover" role="menu">
        <button type="button" role="menuitem" onClick={() => selectAction('archive')}>
          <Archive size={15} /> Archive
        </button>
        <button
          className="danger"
          type="button"
          role="menuitem"
          onClick={() => selectAction('delete')}
        >
          <Trash2 size={15} /> Delete
        </button>
      </div>
    </div>
  );
}
